import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function c({
  size: t = "small",
  accessibilityTitle: l = "glyph pin solid",
  className: C,
  "data-testid": s,
  fill: a,
  stroke: i
}) {
  const n = () => o(C, r["ride-glyph"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: n(), "data-testid": s }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: a || "#03050F",
      stroke: i || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    l && /* @__PURE__ */ e.createElement("title", null, l),
    /* @__PURE__ */ e.createElement("path", { d: "M16.0029 3.99634C13.6162 3.99785 11.3278 4.9466 9.64019 6.6342C7.95258 8.3218 7.00383 10.6102 7.00232 12.9969C7.00545 15.8168 8.00106 18.5457 9.81463 20.7051L16.0029 28.0547L22.1911 20.7051C24.0085 18.5479 25.0047 15.8176 25.0034 12.9969C25.0019 10.6102 24.0531 8.3218 22.3655 6.6342C20.6779 4.9466 18.3895 3.99785 16.0029 3.99634ZM16.0029 15.9971C15.2072 15.9971 14.444 15.681 13.8814 15.1183C13.3188 14.5557 13.0027 13.7926 13.0027 12.9969C13.0027 12.2012 13.3188 11.4381 13.8814 10.8754C14.444 10.3128 15.2072 9.9967 16.0029 9.9967C16.3968 9.9967 16.787 10.0743 17.151 10.2251C17.515 10.3758 17.8457 10.5968 18.1243 10.8754C18.4029 11.154 18.6239 11.4848 18.7747 11.8488C18.9254 12.2128 19.003 12.6029 19.003 12.9969C19.003 13.3909 18.9254 13.781 18.7747 14.145C18.6239 14.509 18.4029 14.8397 18.1243 15.1183C17.8457 15.3969 17.515 15.6179 17.151 15.7687C16.787 15.9194 16.3968 15.9971 16.0029 15.9971V15.9971Z" })
  ));
}
export {
  c as RideGlPinSolid
};
